/**
 * Auth providers (Google, Apple)
 */
import { GoogleAuthProvider, OAuthProvider, signInWithPopup, signInWithRedirect, getRedirectResult, } from 'firebase/auth';
import { getFirebaseAuth } from './firebase.js';
/**
 * Sign in with Google
 */
export async function signInWithGoogle(useRedirect = false) {
    const auth = getFirebaseAuth();
    const provider = new GoogleAuthProvider();
    // Request additional scopes if needed
    provider.addScope('email');
    provider.addScope('profile');
    if (useRedirect) {
        await signInWithRedirect(auth, provider);
        return null; // Will redirect, so return null
    }
    return signInWithPopup(auth, provider);
}
/**
 * Sign in with Apple
 */
export async function signInWithApple(useRedirect = false) {
    const auth = getFirebaseAuth();
    const provider = new OAuthProvider('apple.com');
    // Request scopes
    provider.addScope('email');
    provider.addScope('name');
    if (useRedirect) {
        await signInWithRedirect(auth, provider);
        return null;
    }
    return signInWithPopup(auth, provider);
}
/**
 * Handle redirect result (call on page load if using redirect)
 */
export async function handleRedirectResult() {
    const auth = getFirebaseAuth();
    return getRedirectResult(auth);
}
/**
 * Get auth provider for provider ID
 */
export function getProviderForId(providerId) {
    switch (providerId) {
        case 'google.com':
            return new GoogleAuthProvider();
        case 'apple.com':
            return new OAuthProvider('apple.com');
        default:
            throw new Error(`Unknown provider: ${providerId}`);
    }
}
//# sourceMappingURL=providers.js.map